import Vue from 'vue';
import Vuex from 'vuex';

import device from './modules/device';
import network from './modules/network';
import auth from './modules/auth';
import user from './modules/user';
import loyaltyTiers from './modules/loyaltyTiers';
import referrals from './modules/referrals';
import userContests from './modules/userContests';
import firebase from './modules/firebase';
import firebaseAnalytics from './modules/firebaseAnalytics';
import universalLinks from './modules/universalLinks';
import branch from './modules/branch';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    device,
    network,
    auth,
    user,
    loyaltyTiers,
    referrals,
    userContests,
    firebase,
    firebaseAnalytics,
    universalLinks,
    branch,
  },
  strict: debug,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js